import {useState} from "react";
import moment from "moment";
import {useFetch} from "../../../../../hooks/useFetch";
import {useStore} from "../../../../../hooks/useStore";

export const useCourierWallet = ({courierLoading, courier, canRender, reloadWallet}) => {
    const stores = useStore();
    const [wallet, setWallet] = useState(null);
    const [recallWallet, setRecallWallet] = useState(false);
    const [walletLoading] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.walletStore.getCourierWalletWithDailyTransactionsSummary.bind(null, {
            courierId: courier?._id,
            startDate: moment()
                .subtract(7, "day")
                ?.format("YYYY-MM-DD"),
            endDate: moment()?.format("YYYY-MM-DD")
        }),
        dependencies: [courier?._id, canRender, reloadWallet, recallWallet],
        initialCall: Boolean(courier?._id) && canRender,
        condition:
            Boolean(courier?._id) &&
            Boolean(courier?.isWalletActive) &&
            canRender &&
            !courierLoading,
        callbackFunc: result => {
            setWallet(result?.data);
        },
        waitForResponse: true
    });

    const refreshWallet = () => {
        setRecallWallet(!recallWallet);
    };

    return {
        wallet,
        walletLoading,
        refreshWallet
    };
};
